// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__t_7vA","columns":"styles_columns__fxEQB","column":"styles_column__pY9c7","image":"styles_image__ri71p","image--second":"styles_image--second__Yepmt"};